import { ArrowLeft, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';
import { SUPPORT_EMAIL } from '../utils/support';
import BrandLogo from '../components/BrandLogo';

export default function SupportPage() {
  return (
    <div className="standalone-screen">
      <header className="bg-navy text-white">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center justify-between">
          <BrandLogo variant="white" className="h-10 w-10" />
          <Link
            to="/login"
            className="inline-flex items-center gap-1 text-sm text-white/80 hover:text-white transition"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to sign in
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-8">
        <section className="bg-white rounded-2xl shadow-sm p-6 sm:p-10">
          <h1 className="text-3xl font-bold text-navy mb-4">Iron Forums Support</h1>
          <p className="text-gray-700 leading-relaxed mb-6">
            For help signing in, managing your membership, or using the Iron Forums app,
            contact our support team.
          </p>
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className="inline-flex items-center gap-2 bg-navy text-white px-5 py-3 rounded-lg font-semibold hover:bg-navy-dark transition"
          >
            <Mail className="w-5 h-5" />
            {SUPPORT_EMAIL}
          </a>
          <p className="text-sm text-gray-500 mt-6">
            Please do not include passwords, payment card details, or sensitive personal
            information in your message.
          </p>
        </section>
        <div className="text-center mt-6 text-sm text-gray-500 space-x-4">
          <Link to="/privacy" className="text-navy underline hover:text-gold">
            Privacy Policy
          </Link>
          <Link to="/terms" className="text-navy underline hover:text-gold">
            Terms of Service
          </Link>
        </div>
      </main>
    </div>
  );
}
